module.exports = __webpack_public_path__ + "img/ERROR_UNKNOWN.35d01b29.svg";